import { render } from "./ButtonSquare.vue?vue&type=template&id=02fccad4"
import script from "./ButtonSquare.vue?vue&type=script&lang=js"
export * from "./ButtonSquare.vue?vue&type=script&lang=js"

import "./ButtonSquare.vue?vue&type=style&index=0&id=02fccad4&lang=scss"

import exportComponent from "C:\\Users\\Raska\\Desktop\\raska\\projekat\\astra\\astra-app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__